import React from 'react';

export const PIXEL_IMAGE_STYLE = {
    imageRendering: 'pixelated',
    width: 'auto',
    height: 'auto',
    maxWidth: 'none',
    maxHeight: 'none',
    objectFit: 'none',
    flexShrink: 0,
};

export const PLACEHOLDER_LARGE = `${process.env.PUBLIC_URL}/img/Placeholder.png`;
export const PLACEHOLDER_SMALL = `${process.env.PUBLIC_URL}/img/Placeholder_s.png`;

export const FURNI_RENDER_BASE = 'https://furni.franklyorigins.net/api/furniture/render';
export const FURNI_INFO_BASE = 'https://furni.franklyorigins.net/api/FurniInfo';

export const FURNI_DIRECTIONS = [0, 1, 2, 3, 4, 5, 6, 7];

export const buildRenderUrl = (code, type, direction = 0) => {
    const raw = String(code || '').trim().replace(/%2a/gi, '*');
    if (!raw) return null;

    const star = raw.indexOf('*');
    const base = star === -1 ? raw : raw.slice(0, star);
    const rest = star === -1 ? '' : raw.slice(star);

    let furni = raw;
    if (type === 'small') furni = `s_${raw}`;
    else if (type === 'icon') furni = `${base}_small${rest}`;

    const params = new URLSearchParams({
        furni,
        direction: String(direction),
        state: '1',
        frame: '0',
        width: '120',
        height: '120',
    });

    return `${FURNI_RENDER_BASE}?${params.toString()}`;
};

export function FurniThumb({ src, alt, size = 60, fallback = PLACEHOLDER_SMALL }) {
    return (
        <div
            className="flex shrink-0 items-center justify-center overflow-hidden border border-gray-200 bg-gray-50"
            style={{ width: size, height: size }}
        >
            <img
                src={src || fallback}
                alt={alt || ''}
                style={PIXEL_IMAGE_STYLE}
                onError={(e) => { e.target.src = fallback; }}
            />
        </div>
    );
}

export const formatNumber = (value) => (value === null || value === undefined || value === '')
    ? '-'
    : Number(value).toLocaleString('en-GB');

export const relativeFromMinutes = (minutes) => {
    if (minutes === null || minutes === undefined) return 'never';
    const m = Math.max(0, Number(minutes));
    if (m < 1) return 'just now';
    if (m < 60) return `${Math.floor(m)} min ago`;

    const hours = Math.floor(m / 60);
    if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

    const days = Math.floor(hours / 24);
    if (days < 31) return `${days} day${days === 1 ? '' : 's'} ago`;

    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`;

    const years = Math.floor(days / 365);
    return `${years} year${years === 1 ? '' : 's'} ago`;
};

export const ageTone = (days, staleDays) => {
    if (days === null || days === undefined) return 'bad';
    if (days >= staleDays * 2) return 'bad';
    if (days >= staleDays) return 'warn';
    return 'good';
};

export const TONE_TEXT = {
    good: 'text-green-700',
    warn: 'text-orange-600',
    bad: 'text-red-600',
};

export function TrendPill({ trend, delta }) {
    if (trend === 'new') {
        return (
            <span className="whitespace-nowrap border border-blue-300 bg-blue-100 px-1.5 py-0.5 text-[10px] font-bold uppercase text-blue-700">
                First value
            </span>
        );
    }

    const config = {
        up: { className: 'border-green-300 bg-green-100 text-green-700', arrow: '▲' },
        down: { className: 'border-red-300 bg-red-100 text-red-700', arrow: '▼' },
        same: { className: 'border-gray-300 bg-gray-100 text-gray-600', arrow: '=' },
    }[trend] || { className: 'border-gray-300 bg-gray-100 text-gray-600', arrow: '=' };

    return (
        <span className={`whitespace-nowrap border px-1.5 py-0.5 text-[10px] font-bold uppercase ${config.className}`}>
            {config.arrow} {delta === null || delta === undefined || delta === 0 ? 'no change' : formatNumber(Math.abs(delta))}
        </span>
    );
}

export const bobbaSearchUrl = (term) => `https://bobba.me/rares?q=${encodeURIComponent(String(term || '').trim())}`;
